import axiosInstance from '@/lib/axios';
import {
  UploadMediaResponse,
  GetUserMediaResponse,
  GetMediaByIdResponse,
  DeleteMediaResponse,
  GetStorageInfoResponse,
  MediaType,
} from '../types/media.types';

export const mediaService = {
  // Upload media file
  uploadMedia: async (file: File): Promise<UploadMediaResponse> => {
    const formData = new FormData();
    formData.append('file', file);

    const response = await axiosInstance.post<UploadMediaResponse>(
      '/media/upload',
      formData,
      {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      }
    );
    return response.data;
  },

  // Get user's media files
  getUserMedia: async (type?: MediaType): Promise<GetUserMediaResponse> => {
    const params = type ? { type } : {};
    const response = await axiosInstance.get<GetUserMediaResponse>('/media', {
      params,
    });
    return response.data;
  },

  // Get specific media by ID
  getMediaById: async (mediaId: string): Promise<GetMediaByIdResponse> => {
    const response = await axiosInstance.get<GetMediaByIdResponse>(
      `/media/${mediaId}`
    );
    return response.data;
  },

  // Delete media file
  deleteMedia: async (mediaId: string): Promise<DeleteMediaResponse> => {
    const response = await axiosInstance.delete<DeleteMediaResponse>(
      `/media/${mediaId}`
    );
    return response.data;
  },

  // Get user storage information
  getStorageInfo: async (): Promise<GetStorageInfoResponse> => {
    const response = await axiosInstance.get<GetStorageInfoResponse>(
      '/media/storage'
    );
    return response.data;
  },
};